import {Injectable} from '@angular/core';
import {GenericCrudService} from '../../../../../services/generic-crud.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Entity} from '../../../../../helpers/entity';

@Injectable()
export class SalaryTypeAutocompleteHandler {

  public constructor(
    private genericCrudService: GenericCrudService
  ) {

  }

  public getData(query: string): Observable<any[]> {
    const route = `phoenix/salarytypes/offset/0/limit/30/orderby/id/asc?search=${query}`,
      requestParams = {
        clause: 'orWhere',
        parent: 'isNull:'
      };

    return this.genericCrudService.getEntities(route, '', requestParams)
      .pipe(map((paginated: {data: any[]}) => {
        const data = paginated.data;

        for (const type of data) {
          type.label = `${Entity.getValue(type, 'name')} (${Entity.getValue(type, 'code')})`;
        }

        return data;
      }));
  }
}
